// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_ProductionHistoryResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/production_history/{order_item_id}.
 */
import type { Orders_ProductionLogRow } from './Orders_ProductionLogRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orders_ProductionHistoryResponseDados = Orders_ProductionLogRow[];

export type Orders_ProductionHistoryResponse = ApiResponse<Orders_ProductionHistoryResponseDados>;

registerResponseContract('Orders_ProductionHistoryResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_production_log_id:                 { type: 'number',  required: true },
      so_production_log_order_item_id:      { type: 'number',  required: true },
      so_production_log_production_step_id: { type: 'number',  required: false },
      so_production_log_work_order_step_id: { type: 'number',  required: false },
      so_production_log_action:             { type: 'string',  required: true },
      so_production_log_expected_step_name: { type: 'string',  required: false },
      so_production_log_scanned_by:         { type: 'string',  required: true },
      so_production_log_scanned_at:         { type: 'string',  required: true },
      so_production_log_notes:              { type: 'string',  required: false },
      so_production_log_created_at:         { type: 'string',  required: true },
      scanned_step_name:                    { type: 'string',  required: false },
      scanned_by_name:                      { type: 'string',  required: false },
    },
  },
})
